<ng-container *transloco="let t">
  <!-- breadcrumbs -->
  <div class="z-20">
    <div class="w-full" #breadcrumbsContainer [class.pb-lg]="breadcrumbsContainer.childNodes.length">
      <ng-content select="cft-breadcrumbs, cft-back-button"></ng-content>
    </div>
  </div>

  <!-- cover block -->
  <div
    class="grid h-full grid-cols-1 text-secondary md:grid-cols-12 md:grid-rows-2"
    [class.min-h-[320px]]="emptyCover()"
    style="grid-template-rows: auto; grid-auto-rows: fit-content(100%)"
  >
    <div
      class="relative flex flex-col justify-center overflow-hidden rounded-3 shadow-3 md:col-start-1 md:col-end-13 md:row-span-1 md:row-start-1"
    >
      <!-- background image -->

      <cft-wave-cover-image [reducedCoverTransparency]="reducedCoverTransparency()" class="-z-10">
        <ng-container content="background-image">
          <ng-content select="[content=background-image]"></ng-content>
        </ng-container>
      </cft-wave-cover-image>

      <!-- title, description and icon -->
      <div class="z-20 order-1 mb-2xl flex items-center pt-3xl">
        <div class="w-full">
          <!-- main area -->
          <div class="mx-xl flex flex-col items-start gap-sm md:w-1/2 md:flex-row md:gap-md">
            <!-- red dot with margin 1/2 the size of line-height to align text -->
            @if (title()) {
              <div class="bg-vermilion-500 h-[16px] w-[16px] min-w-[16px] md:mt-[0.6rem]"></div>
            }
            <!-- title & description box -->
            <div class="text-left">
              @if (title()) {
                <h1 class="heading-2xl">
                  {{ title() }}
                </h1>
              }
              @if (description()) {
                <h2 class="mt-md text-base font-medium md:text-md">
                  {{ description() }}
                </h2>
              }
              @if (showCallToAction()) {
                <div class="mt-xl md:mt-lg">
                  <ng-content select="bgo-hero-call-to-action-section"></ng-content>
                </div>
              }
              @if (showSearch()) {
                <div class="mt-xl md:mt-lg">
                  <ng-content select="bgo-hero-search"></ng-content>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- selling point bar -->
      @if (showSellingPointBar()) {
        <div class="order-2 md:col-start-1">
          <ng-content select="bgo-hero-selling-point"></ng-content>
        </div>
      }
    </div>

    <!-- partnership section, below the background cover -->
    @if (showPartnership()) {
      <div class="order-3 md:col-start-1 md:col-end-13 md:row-start-2">
        <div class="h-layout flex w-full flex-row justify-between py-lg text-primary">
          <ng-content select="bgo-hero-partnership"></ng-content>
        </div>
      </div>
    }

    @if (showTags()) {
      <div
        class="order-4 md:col-start-1"
        [class.md:row-start-3]="showPartnership()"
        [class.md:row-start-2]="!showPartnership()"
        [class.md:col-end-13]="!showOverlay() || showPartnership()"
        [class.md:col-end-8]="showOverlay() && !showPartnership()"
      >
        <div class="h-layout flex w-full flex-row justify-between pt-lg text-primary">
          <ng-content select="bgo-hero-tags"></ng-content>
        </div>
      </div>
    }

    <!-- form section -->
    @if (showOverlay()) {
      <div class="order-2 pb-xl md:col-start-1 md:col-end-13 md:row-span-2 md:row-start-1">
        <div class="h-layout pt-(--navbar-height-mobile) md:pt-(--navbar-height)">
          <div class="grid grid-cols-1 md:grid-cols-12">
            <div class="z-20 md:col-span-5 md:col-start-8">
              <ng-content select="bgo-hero-form, [content=overlay]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</ng-container>
